<template>
  <div :class="{'op--modal-container':true, 'hide':!show}">
    <div class="op--modal">
      <div class="op--modal-content" id="form">
        <div class="form">
          <div class="heading">DELETING DEDUCTION</div>
          <div class="message" v-if="item !== null">
            <span>Are you sure you want to delete the deduction with the name</span>
            <strong>{{ item.name }}?</strong>
          </div>
          <div class="error" v-show="error.show">{{ error.message }}</div>
          <div class="fixed-footer">
            <div :class="{'button cta small warning':true, 'disabled':deleting}"
              @click="close">NO</div>
            <div :class="{'button cta small':true, 'disabled':deleting}"
              @click="submitDelete">YES</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'deduction-delete',
  data () {
    return {
      deleting: false,
      error: {
        show: false,
        message: 'Please select a valid value'
      }
    }
  },
  computed: {
    item () { return this.$store.state.providerDeductions.deductionDelete.item },
    show () { return this.$store.state.providerDeductions.deductionDelete.show }
  },
  methods: {
    close () {
      this.$store.commit('providerDeductions/setDeductionDeleteShow', false)
      this.$store.commit('providerDeductions/setDeductionDeleteItem', null)
    },
    submitDelete () {
      let self = this
      self.deleting = true
      self.$sdk.delete('/admin/providerdeduction/' + self.item.id, {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.deleting = false
        if (r.error) {
          self.error = {
            show: true,
            message: r.error.message
          }
          return
        }
        self.close()
        self.$store.commit('providerDeductions/setDeductionListReload', true)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.op--modal {
  display: table;
  width: 100%;
  height: 100%;
}
.op--modal-content {
  display: table-cell;
  vertical-align: middle;
}
.form{
  background: #fff;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  border-radius: 5px;
  overflow: hidden;
}
.heading{
  background: #333;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  padding: 10px 20px;
  margin-bottom: 20px;
}

.message {
  text-align: center;
  padding: 0 20px 10px;
}

.error {
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  color: #F25E0D;
  border: 2px solid #F25E0D;
  padding: 10px;
  margin: 10px 20px 20px;
  border-radius: 5px;
}

.fixed-footer{
  width: 100%;
  background: #f3f3f3;
  border-top:1px solid #ccc;
  padding: 15px 10px;
  text-align: center;
  margin-top: 15px;

  .button{
    min-width: 120px;
    margin: 0 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProviderDeductions/DeductionDelete.vue